import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      services: 'Hizmetler',
      blog: 'Blog',
      contact: 'İletişim',
      admin: 'Admin'
    },
    hero: {
      title: 'Gelecek İçin Bilgi ve Teknoloji',
      subtitle: 'MERTT ile yenilikçi çözümler ve ileri teknoloji hizmetleri',
      cta: 'Hizmetlerimizi Keşfedin'
    },
    services: {
      title: 'Hizmetlerimiz',
      subtitle: 'Teknoloji ve inovasyonda öncü çözümler'
    },
    about: {
      title: 'Hakkımızda',
      content: 'MERTT, gelecek için bilgi ve teknoloji vizyonuyla, makina, AR-GE, yazılım ve tasarım alanlarında öncü hizmetler sunmaktadır. Yenilikçi yaklaşımımız ve uzman ekibimizle, müşterilerimize en iyi çözümleri sağlıyoruz.'
    },
    contact: {
      title: 'İletişim',
      name: 'Adınız',
      email: 'E-posta',
      subject: 'Konu',
      message: 'Mesajınız',
      send: 'Gönder',
      success: 'Mesajınız başarıyla gönderildi!',
      error: 'Bir hata oluştu. Lütfen tekrar deneyin.'
    },
    blog: {
      title: 'Blog',
      readMore: 'Devamını Oku',
      back: 'Geri Dön',
      latest: 'Son Yazılar'
    },
    admin: {
      login: 'Giriş Yap',
      email: 'E-posta',
      password: 'Şifre',
      dashboard: 'Yönetim Paneli',
      logout: 'Çıkış Yap',
      services: 'Hizmetler',
      products: 'Ürünler',
      blogs: 'Bloglar',
      messages: 'Mesajlar',
      settings: 'Ayarlar',
      add: 'Ekle',
      edit: 'Düzenle',
      delete: 'Sil',
      save: 'Kaydet',
      cancel: 'İptal',
      changePassword: 'Şifre Değiştir',
      currentPassword: 'Mevcut Şifre',
      newPassword: 'Yeni Şifre',
      confirmPassword: 'Yeni Şifre (Tekrar)'
    },
    products: {
      buy: 'Satın Al',
      price: 'Fiyat',
      details: 'Detaylar'
    },
    footer: {
      rights: 'Tüm hakları saklıdır.',
      about: 'Hakkımızda',
      services: 'Hizmetler',
      blog: 'Blog',
      contact: 'İletişim'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      blog: 'Blog',
      contact: 'Contact',
      admin: 'Admin'
    },
    hero: {
      title: 'Knowledge & Technology for the Future',
      subtitle: 'Innovative solutions and advanced technology services with MERTT',
      cta: 'Explore Our Services'
    },
    services: {
      title: 'Our Services',
      subtitle: 'Leading solutions in technology and innovation'
    },
    about: {
      title: 'About Us',
      content: 'MERTT provides pioneering services in machinery, R&D, software, and design with a vision of knowledge and technology for the future. With our innovative approach and expert team, we deliver the best solutions to our clients.'
    },
    contact: {
      title: 'Contact',
      name: 'Your Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Your Message',
      send: 'Send',
      success: 'Your message has been sent successfully!',
      error: 'An error occurred. Please try again.'
    },
    blog: {
      title: 'Blog',
      readMore: 'Read More',
      back: 'Go Back',
      latest: 'Latest Posts'
    },
    admin: {
      login: 'Login',
      email: 'Email',
      password: 'Password',
      dashboard: 'Dashboard',
      logout: 'Logout',
      services: 'Services',
      products: 'Products',
      blogs: 'Blogs',
      messages: 'Messages',
      settings: 'Settings',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      changePassword: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm New Password'
    },
    products: {
      buy: 'Buy Now',
      price: 'Price',
      details: 'Details'
    },
    footer: {
      rights: 'All rights reserved.',
      about: 'About',
      services: 'Services',
      blog: 'Blog',
      contact: 'Contact'
    }
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('tr');

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}